import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { requestChangePassword } from "../../store/user/user.thunks";
import {
  setIsNavigationOpen,
  setIsNavigationID,
  setIsNavigationName,
  setIsAnimatedMenu,
  setIsMoreDetailed,
  setIsDetailedGroup,
  setIsDetailedGroupName,
  setIsOpenSport,
  setIsEventDetailed,
  setRenderIonContent,
  setSportsName,
  setHrMarketId,
  setHrEventId,
  setHrCountryCode,
} from "../../store/navigationHeaderMenu/navigationHeaderMenu.slice";
import { setLoginNew } from "../../store/LoginNew/loginNew.slice";
import { requestSportPageEventDetailed } from "../../store/sportPageEvent/sportPageEvent.thunks";
import { requestSportData } from "../../store/sportEvent/sportEvent.thunks";
import {
  setSlotCasinoPopUp,
  openSlotCasinoPopUp,
} from "../../store/slotCasinoPopUp/slotCasinoPopUp.slice";
import { requestMenu } from "../../store/menu/menu.thunks";
import { getMenuSuccess } from "../../store/menu/menu.slice";
import {
  requestHomeAllCompetition,
  requestHomeAllEvents,
} from "../../store/homeMarketEvents/homeMarketEvents.thunks";
import {
  getFreeHomeAllMarketsError,
  getFreeHomeAllMarketsSuccess,
  getHomeAllCompetitionSuccess,
  getHomeAllEventsError,
  getHomeAllCompetitionError,
} from "../../store/homeMarketEvents/homeMarketEvents.slice";
import { setCasinoType } from "../../store/casinoprovider/casinoprovider.slice";
import { setLoginNavigationData } from "../../store/loginNavigation/LoginNavigation.slice";
import { setComingSoonModal } from "../../store/modals/comingSoonModal.slice";
import { requestRacingPageData } from "../../store/racingPage/racingPage.thunks";

export const connectLeftSideMenuDesktop = (wrappedProps) => (component) => {
  function mapStateToProps(state) {
    return {
      menu: state.menu,
      timeSettings: state.timeSettings,
      auth: state.auth,
      user: state.user,
      sportPageEvent: state.sportPageEvent,
      sportItemData: state.sportItemData,
      moreDetailed: state.navigationHeaderMenu.moreDetailed,
      eventDetailed: state.navigationHeaderMenu.eventDetailed,
      detailedGroupName: state.navigationHeaderMenu.detailedGroupName,
      sportsName: state.navigationHeaderMenu.sportsName,
      slotCasinoPopUp: state.slotCasinoPopUp,
      homeMarketEvents: state.homeMarketEvents,
      competition: state.competition,
      navigationName: state.navigationHeaderMenu.navigationName,
      sportData: state.racingPage,
      hrEventId: state.navigationHeaderMenu.hrEventId,
      hrMarketId: state.navigationHeaderMenu.hrMarketId,
    };
  }

  function mapDispatchToProps(dispatch) {
    const actions = {
      requestSportPageEventDetailed,
      requestSportData,

      setIsNavigationOpen,
      setIsNavigationID,
      setIsNavigationName,
      setIsAnimatedMenu,
      setIsMoreDetailed,
      setIsDetailedGroup,
      setIsDetailedGroupName,
      setLoginNew,
      setIsOpenSport,
      setIsEventDetailed,
      setRenderIonContent,
      setSportsName,
      setSlotCasinoPopUp,
      openSlotCasinoPopUp,
      requestMenu,
      getMenuSuccess,
      requestHomeAllCompetition,
      getHomeAllCompetitionSuccess,
      getFreeHomeAllMarketsSuccess,
      getFreeHomeAllMarketsError,
      getHomeAllEventsError,
      getHomeAllCompetitionError,
      requestHomeAllEvents,
      setCasinoType,
      setLoginNavigationData,
      setComingSoonModal,
      requestRacingPageData,
      setHrEventId,
      setHrMarketId,
      setHrCountryCode,
    };

    return { actions: bindActionCreators(actions, dispatch) };
  }

  return connect(mapStateToProps, mapDispatchToProps)(component);
};
